<script setup lang="ts">
import { defineProps, defineEmits } from "vue";

defineProps<{
  label: string;
  modelValue: string;
  type: "text" | "password" | "email";
}>();

const emits = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

function handleInput(event: Event) {
  emits("update:modelValue", (event.target as HTMLInputElement).value);
}
</script>

<template>
  <div class="flex flex-col gap-2 w-full">
    <label class="text-brown text-base leading-[20px] select-none sf-pro">
      {{ label }}
    </label>
    <input
      class="w-full h-[52px] rounded-[14px] border border-muted px-4 text-brown focus:outline-none sf-pro"
      :type="type"
      :value="modelValue"
      @input="handleInput($event)"
    />
  </div>
</template>
